import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    TextField,
    Button,
} from "@material-ui/core";
import HttpService from "../services/httpService";

const MAX_AMOUNT = 2500;

const SiteVisitPaymentRaiseModal = ({ open, onClose, sourceLeadId, setLoading, setSnackInfo }) => {
    const [referrerIdentifier, setReferrerIdentifier] = useState("");
    const [amount, setAmount] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleClose = () => {
        if (submitting) return;
        setReferrerIdentifier("");
        setAmount("");
        setError("");
        onClose();
    };

    const handleSubmit = async () => {
        setError("");
        if (!referrerIdentifier.trim()) {
            setError("Enter the referrer's Unique Lead Number or Lead Number");
            return;
        }
        const parsedAmount = Number(amount);
        if (!parsedAmount || parsedAmount <= 0 || parsedAmount > MAX_AMOUNT) {
            setError(`Amount must be greater than 0 and cannot exceed ₹${MAX_AMOUNT}`);
            return;
        }

        // Accept either a numeric lead number or an alphanumeric unique lead number.
        const isNumeric = /^\d+$/.test(referrerIdentifier.trim());
        const payload = {
            amount: parsedAmount,
            sourceLeadId,
            ...(isNumeric
                ? { referrerLeadNo: referrerIdentifier.trim() }
                : { referrerUniqueLeadNumber: referrerIdentifier.trim() }),
        };

        try {
            setSubmitting(true);
            setLoading(true);
            const response = await HttpService.raiseSiteVisitPaymentRequest(payload);
            setLoading(false);
            setSubmitting(false);
            if (response.data.success) {
                setSnackInfo(response.data.message || "Sent for DGM/AGM approval", "success");
                handleClose();
            } else {
                setSnackInfo(response.data.message || "Failed to raise request", "error");
            }
        } catch (err) {
            setLoading(false);
            setSubmitting(false);
            console.error("Error raising site visit payment request:", err);
            setSnackInfo(err?.response?.data?.message || "Failed to raise request", "error");
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>Raise Site Visit Payment Request</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Enter the referrer's (property holder's) Unique Lead Number or Lead Number, and the amount to be paid (capped at ₹{MAX_AMOUNT}).
                </DialogContentText>
                <TextField
                    fullWidth
                    autoFocus
                    label="Referrer's Unique Lead Number / Lead Number"
                    value={referrerIdentifier}
                    onChange={(e) => setReferrerIdentifier(e.target.value)}
                    margin="dense"
                />
                <TextField
                    fullWidth
                    label="Amount"
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    inputProps={{ max: MAX_AMOUNT, min: 1 }}
                    margin="dense"
                />
                {error && (
                    <DialogContentText style={{ color: "#f44336", marginTop: 8 }}>
                        {error}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={submitting}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained" disabled={submitting}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SiteVisitPaymentRaiseModal;
